import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/table/comparator',
      name: 'table-comparator',
      component: () =>
        import(/* webpackChunkName: "table_comparator" */ './views/Table-Comparator.vue')
    },
    {
      path: '/sped/bloco-k',
      name: 'sped-bloco-k',
      component: () =>
        import(/* webpackChunkName: "sped_bloco-k" */ './views/Sped-BlocoK.vue')
    },
    {
      path: '/sped/ajuste-c197',
      name: 'sped-ajuste-c197',
      component: () => import(/* webpackChunkName: "sped_ajuste-c197" */'./views/Sped-AjusteC197.vue')
    },
    {
      path: '/table/cliente-fornecedor',
      name: 'cliente-fornecedor',
      component: () =>
        import(/* webpackChunkName: "table_cliente-fornecedor" */ './views/Table-ClienteFornecedor.vue')
    },
    {
      path: '/table/arquivo-contabil',
      name: 'arquivo-contabil',
      component: () =>
        import('./views/Table-Contabil.vue')
    }
  ]
})
